module.exports = __webpack_public_path__ + "media/images/area-badges/biodiversity-79b6d2cd9038369704e591efcd3b7ec4.svg";